let parsePhoneNumberPromise: Promise<
  (phoneNumber: string, options?: { regionCode?: string }) => any
> | null = null

export const usePhoneNumber = () => {
  const getParsePhoneNumber = () => {
    if (!parsePhoneNumberPromise) {
      parsePhoneNumberPromise = import('awesome-phonenumber')
        .then(module => module.parsePhoneNumber)
        .catch(error => {
          parsePhoneNumberPromise = null
          throw error
        })
    }

    return parsePhoneNumberPromise
  }

  const isValidPhoneNumber = async (phoneNumber: string, regionCode?: string) => {
    const stripped = phoneNumber.replace(/-|\s/g, '')
    const parsePhoneNumber = await getParsePhoneNumber()
    return parsePhoneNumber(stripped, { regionCode }).valid
  }

  const formatPhoneNumber = async (phoneNumber: string, regionCode?: string) => {
    const stripped = phoneNumber.replace(/-|\s/g, '')
    const parsePhoneNumber = await getParsePhoneNumber()
    return parsePhoneNumber(stripped, { regionCode })?.number?.e164 || ''
  }

  return { isValidPhoneNumber, formatPhoneNumber }
}
